import React from "react";
import MembOtpRegChkApi from "Apis/MembOtpRegChkApi";
import { useEffect, useState } from "react";
import { Navigate, useNavigate, useOutletContext } from "react-router-dom";
import { useSelector } from "react-redux";
import MbpAthnRsltVrfRqstApi from "Apis/MbpAthnRsltVrfRqstApi";
import MbpAthnUi from "Utils/MbpAthn";
import MembOtpRegScrtApi from "Apis/MembOtpRegScrtApi";
import MgpStore from "Stores/Store";
import { Helmet } from "react-helmet-async";
import TrmsCtxtInqApi from "Apis/TrmsCtxtInqApi";
import UseLangLstQuery from "Apis/LangTxtInqApi";
import refererApi from "Apis/refererApi";


const AppMembEmlChngUi = () => {
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const navigate = useNavigate();
    const idntMthdCd = useSelector((state: any) => state.IdntMthdCdState?.IdntMthdCd);
    const [otpRegYn,setotpRegYn] = useState<any>();
    
    useEffect(() => {
        refererApi();
    }, [idntMthdCd, navigate]);
    const [emlAthnPrpsCd] =useState("EML_CHNG");
    var popupX = Math.round(window.screenX + (window.outerWidth/2) - (500/2));
    var popupY = Math.round(window.screenY + (window.outerHeight/2) - (670/2));
    const EmlAthnPopFunc = (e:any)=>{
        window.open(e,"_blank","width=550,height=800 left="+popupX+"top="+popupY);
    }
    useEffect(()=>{
        MembOtpRegChkApi()
        .then((resp) => {
            setotpRegYn(resp.apiBody);
        })
        function kmcRespFunc (kmcApiTknrslt:string,kmcApiCertNumrslt:string){
            MbpAthnRsltVrfRqstApi(kmcApiTknrslt,kmcApiCertNumrslt)
            .then((resp) => {
                if(resp.apiHdr.code == "ATHN0000") {

                        navigate("/Connect/MyPage/EmlChngInput");
                }
            });
        }
        window.kmcRespFunc = kmcRespFunc;
        const emlAthnRespFunc =() => {
            return navigate("/Connect/MyPage/EmlChngInput");
        }
        window.emlAthnRespFunc = emlAthnRespFunc;
        
    },[]);
    return(
        <>
        <Helmet>
            <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.MYPAGE_MENU_EML_CHNG_BTN_00}`}</title>
        </Helmet>
        <div className="loginInputWrap">
            <div className="myPageSubTitlWrap">
                <p className="myPageCtxtTitl">{langData&&langData.MYPAGE_MENU_EML_CHNG_BTN_00}</p>
            </div>
            {/* OTP 설정 */}
            <div className="myPageSubCtxtWrap">
                <img className="otpImg" src={process.env.PUBLIC_URL+"/images/Connect/Login/otpAthnIcon.png"} alt="" />
                {/* otp 사용 여부 */}
                <div className="otpTxtWrap">
                    <p className="activeText myPageEmlChngActiveText">{langData&&langData.MYPAGE_EML_ATHN_PAGE_TITL_00}</p>
                    <div className="myPageEmlChngMbpAthn loginInputWrap">
                        {MgpStore.getState().IdntMthdCdState.IdntMthdCd === "MBP"?
                            <MbpAthnUi  athnPrpsCd='EML_CHNG'AthnTxt={langData&&langData.COMM_MAIN_ATHN_MAIN_BTN_00} BtnClass="loginBtn"/>
                            :
                            <button onClick={() => EmlAthnPopFunc(`${'/EmlAthnPop?emlAthnPrpsCd=EML_CHNG_ATHN&lang=' +MgpStore.getState().LangSetState.Lang}`)}className="loginBtn">
                                <span>{langData&&langData.COMM_MAIN_ATHN_MAIN_BTN_00}</span>
                                {/* 인증하기 */}
                            </button>
                        }
                    </div>
                </div>
            </div> 
        </div>
        </>
    )
}

export default AppMembEmlChngUi;